export function getTeamRole(teamId, teams, userId) {
  let workMode = 'SOLO';

  if (teamId) {
    const team = teams.find((item) => item.id === teamId);

    if (team) {
      workMode = team.usersId === userId ? 'TEAM_FOUNDER' : 'TEAM_MEMBER';
    }
  }

  return workMode;
}

export const actions = window.sharedActions;
